export default __webpack_public_path__ + "static/top-18d5bcdb2625499a72d7fc390cfa0bc8.png";